import type {CustomDealProduct} from '../../../types';

import {DeleteOutlined, EditOutlined} from '@ant-design/icons';
import {Button, Checkbox} from '@ds/components';
import ProductBadge from '../../../components/common/ProductBadge/ProductBadge';
import StockBadge from '../../../components/common/StockBadge/StockBadge';
import {numberFormat} from 'utils/Helper';

type ApplyDiscountListItemProps = {
  handleProductSelection: (item: CustomDealProduct) => void;
  item: CustomDealProduct;
  selected: boolean;
  handleDeleteProduct?: (id: number | string) => Promise<void>;
  onEditProduct?: (item: CustomDealProduct) => void;
  idToDiscount?: Record<string | number, number>;
};

const ApplyDiscountListItem: React.FC<ApplyDiscountListItemProps> = ({
  handleProductSelection,
  item,
  selected,
  handleDeleteProduct,
  onEditProduct,
  idToDiscount = {}
}) => {
  const discount = idToDiscount[item.id];
  const hasDiscount = discount !== undefined && discount !== null && discount > 0;
  const originalPrice = +item.price || 0;
  const discountedPrice = hasDiscount
    ? Math.round(originalPrice * (1 - discount / 100))
    : originalPrice;
  const stock = item.stock || 0;

  return (
    <div className="flex items-center gap-2.5">
      <div className="flex size-12 items-center justify-center">
        <Checkbox
          checked={selected}
          onChange={(event) => {
            handleProductSelection({...item, selected: event.target.checked});
          }}
        />
      </div>
      <div
        className="flex w-full flex-col gap-1 border-b border-gray-22 py-2 pe-4"
        onClick={() => handleProductSelection({...item, selected: !selected})}
      >
        <div className="flex items-center justify-between">
          <span className="text-body-sm-emphasis text-neutral-fg">{item.title}</span>
          <Button
            variant="ghost"
            size="sm"
            onClick={(event) => {
              event.stopPropagation();
              onEditProduct?.(item);
            }}
          >
            <EditOutlined className="text-body-lg" aria-hidden />
          </Button>
        </div>
        <div className="flex items-start justify-between">
          <div className="my-2 flex flex-wrap gap-1">
            {item.badges?.map((badge) => (
              <ProductBadge key={badge} value={badge} />
            ))}
          </div>
          <StockBadge stock={stock} status={item.stock_status} />
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            {hasDiscount ? (
              <>
                <span className="text-body-xs text-neutral-fg">
                  {numberFormat(originalPrice)} تومان
                </span>
                <span className="inline-flex h-5 min-w-8 items-center justify-center rounded-md bg-orange px-1.5 text-body-xs-emphasis text-white">
                  {discount}%
                </span>
                <span className="text-body-sm-emphasis text-neutral-fg">
                  {numberFormat(discountedPrice)} تومان
                </span>
              </>
            ) : (
              <span className="text-body-sm-emphasis text-neutral-fg">
                {numberFormat(originalPrice)} تومان
              </span>
            )}
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={(event) => {
              event.stopPropagation();
              void handleDeleteProduct?.(item.id);
            }}
          >
            <DeleteOutlined className="text-body-lg" aria-hidden />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApplyDiscountListItem;
